import { 
  signInWithEmailAndPassword,
  signInWithPopup,
  createUserWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail
} from 'firebase/auth';
import { auth, googleProvider } from './config';

// 이메일/비밀번호 로그인
export const signInWithEmail = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return {
      user: userCredential.user,
      error: null
    };
  } catch (error) {
    console.error('로그인 에러:', error);
    let errorMessage = '로그인에 실패했습니다.';
    
    switch (error.code) {
      case 'auth/user-not-found':
        errorMessage = '등록되지 않은 이메일입니다.';
        break;
      case 'auth/wrong-password':
        errorMessage = '잘못된 비밀번호입니다.';
        break;
      case 'auth/invalid-email':
        errorMessage = '유효하지 않은 이메일 형식입니다.';
        break;
      case 'auth/user-disabled':
        errorMessage = '비활성화된 계정입니다.';
        break;
      default:
        errorMessage = '로그인에 실패했습니다. 다시 시도해주세요.';
    }
    
    return {
      user: null,
      error: errorMessage
    };
  }
};

// Google 로그인
export const signInWithGoogle = async () => {
  try {
    const userCredential = await signInWithPopup(auth, googleProvider);
    return {
      user: userCredential.user,
      error: null
    };
  } catch (error) {
    console.error('Google 로그인 에러:', error);
    return {
      user: null,
      error: 'Google 로그인에 실패했습니다. 다시 시도해주세요.'
    };
  }
};

// 회원가입
export const registerWithEmail = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    return {
      user: userCredential.user,
      error: null
    };
  } catch (error) {
    console.error('회원가입 에러:', error);
    let errorMessage = '회원가입에 실패했습니다.';
    
    switch (error.code) {
      case 'auth/email-already-in-use':
        errorMessage = '이미 사용 중인 이메일입니다.';
        break;
      case 'auth/invalid-email':
        errorMessage = '유효하지 않은 이메일 형식입니다.';
        break;
      case 'auth/operation-not-allowed':
        errorMessage = '이메일/비밀번호 회원가입이 비활성화되어 있습니다.';
        break;
      case 'auth/weak-password':
        errorMessage = '비밀번호가 너무 약합니다.';
        break;
      default:
        errorMessage = '회원가입에 실패했습니다. 다시 시도해주세요.';
    }
    
    return {
      user: null,
      error: errorMessage
    };
  }
};

// 로그아웃
export const logOut = async () => {
  try {
    await signOut(auth);
    return { error: null };
  } catch (error) {
    console.error('로그아웃 에러:', error);
    return {
      error: '로그아웃에 실패했습니다. 다시 시도해주세요.'
    };
  }
};

// 비밀번호 재설정 이메일 발송
export const sendPasswordReset = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return {
      error: null,
      message: '비밀번호 재설정 이메일이 발송되었습니다.'
    };
  } catch (error) {
    console.error('비밀번호 재설정 에러:', error);
    let errorMessage = '비밀번호 재설정 이메일 발송에 실패했습니다.';
    
    switch (error.code) {
      case 'auth/invalid-email':
        errorMessage = '유효하지 않은 이메일 형식입니다.';
        break;
      case 'auth/user-not-found':
        errorMessage = '등록되지 않은 이메일입니다.';
        break;
      default:
        errorMessage = '비밀번호 재설정 이메일 발송에 실패했습니다. 다시 시도해주세요.';
    }
    
    return {
      error: errorMessage,
      message: null
    };
  }
};

// 현재 로그인된 사용자 가져오기
export const getCurrentUser = () => {
  return auth.currentUser;
}; 